import React, { Component } from 'react';
import { fileUrl } from '../../../../../../util/file_url'

export default class AudioPreview extends Component {
    // constructor(props) {
    //     super();
    //     this.state = {
    //         isLoading: false,
    //         audioFile: null,
    //     };
    // }

    //fetches data
    // componentDidMount = async () => {
    //     await axios.get(
    //         `http://${window.location.hostname}:3000/api/attachments/${this.props.filename}`
    //     ).then(res => {
    //         this.setState({
    //             audioFile: res.data,
    //         });
    //     }).catch(err => {
    //         window.alert(err)
    //     })
    // }; 

    render() {
        return (
            <div id="attachment-form-preview" style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                overflow: 'hidden'
            }}>
                <audio 
                    preload="metadata" 
                    src={fileUrl(this.props.filename)} 
                    controls 
                    style={{ width: '90%' }}
                />
            </div>
        );
    }
}
